import React, { useEffect } from "react";
import styles from "./EnquireButton.module.css";
import Image from "next/image";
import EnquireNow from "../EnquireNow";

const EnquireButton = ({ data,color }) => {
  
  useEffect(() => {
    document.documentElement.style.setProperty('--button-bg-color', color);
  }, [color]);

  return (
    <>
      {data && (
        <div className={styles.main_container}>
          <button
            className={` ${styles.showMore}`}
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal1"
          >
            <>
              <a
                className={` ${styles.showMore}`}
              >
                {data?.name}
              </a>
              <Image
                src={data?.icon?.results?.[0]?.fileUrl}
                alt="arrow-right"
                height={24}
                width={24}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
            </>
          </button>
          <EnquireNow />
        </div>
      )}
    </>
  );
};

export default EnquireButton;
